import { useEffect, useState } from 'react';

const PricingTableCard = (props) => {
  const {planType, price, list, image, planRanks} = props;

  const buttonText = (isSubscribed, currentPlan, targetPlan, updatePlan) => {
    const normalizedTargetPlan = targetPlan?.toLowerCase();
    const normalizedCurrentPlan = currentPlan?.toLowerCase();

    if (!isSubscribed) return 'Subscribe';
    if (normalizedCurrentPlan === normalizedTargetPlan) return 'Current Plan';

    return planRanks[normalizedTargetPlan] > planRanks[normalizedCurrentPlan] ? 'Upgrade' : 'Update';
  };


  return (
    <div className="col-lg-4 col-md-6 col-sm-8">
        <div className="text-center bg-white single-pricing-pack-2 mt-4 rounded border">
          <div className="pricing-icon">
            <img src={image}  width="150"  alt="" />
          </div>
          <h4 className="package-title h5">{planType}</h4>
          <p className="mb-4">{list[0]}</p>
          <p className="mb-4">{list[1]}</p>
          <p className="mb-4">{list[2]}</p>
          <p className="mb-4">{list[3]}</p>
          <p className="mb-4">{list[4]}</p>
          <div className="pricing-price pt-4">
            <small>Starting at</small>
            <div className="h2">{price} <span className="price-cycle h4">/mo</span></div>
          </div>
          {/*<a href="#" className="btn btn-primary mt-3">Get Started Now</a>*/}
        </div>
      </div>
  );
};

export default PricingTableCard;
